/**
 * Orchestration Center
 * Consolidates Recovery Orchestration + Plan Orchestration
 * DO Phase — ISO 22301 Clause 8.4
 */
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Badge } from "../components/ui/badge";
import RecoveryOrchestrationPage from "./RecoveryOrchestrationPage";
import PlanOrchestrationDashboard from "./PlanOrchestrationDashboard";
import { AlertTriangle, Building2, Layers } from "lucide-react";

export default function OrchestrationCenterPage() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") || "scenario";
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div className="space-y-6" data-testid="orchestration-center-page">
      {/* Unified Header */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Badge variant="outline" className="text-emerald-600 border-emerald-200 bg-emerald-50 text-[10px]">DO Phase</Badge>
          <Badge variant="outline" className="text-slate-500 border-slate-200 text-[10px]">ISO 22301 Clause 8.4</Badge>
        </div>
        <h1 className="text-2xl font-bold text-slate-800" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Orchestration Center
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Consolidated BCP & IT-DRP plan activation — by disaster scenario or business unit
        </p>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="bg-slate-100 p-1">
          <TabsTrigger value="scenario" className="flex items-center gap-1.5 text-xs" data-testid="tab-scenario">
            <AlertTriangle className="w-3.5 h-3.5" /> By Disaster Scenario
          </TabsTrigger>
          <TabsTrigger value="unit" className="flex items-center gap-1.5 text-xs" data-testid="tab-unit">
            <Building2 className="w-3.5 h-3.5" /> By Business Unit
          </TabsTrigger>
        </TabsList>

        <TabsContent value="scenario" className="mt-4">
          <RecoveryOrchestrationPage embedded />
        </TabsContent>

        <TabsContent value="unit" className="mt-4">
          <PlanOrchestrationDashboard embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
